'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// Actions


// Utils


// Components


// Constants


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _elementAttachmentActions = require('../../../../../../../element/elementAttachmentActions');

var _elementActions = require('../../../../../../../element/elementActions');

var _popupActions = require('../../../../../../../components/popupPanel/popupActions');

var _fileValidator = require('../../../../../../../utils/services/file/fileValidator');

var _undoRedoTransactionManager = require('../../../../../../../utils/undoRedo/undoRedoTransactionManager');

var _BoardImagePicker = require('./BoardImagePicker');

var _BoardImagePicker2 = _interopRequireDefault(_BoardImagePicker);

var _mediaConstants = require('../../../../../../../../common/media/mediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchBoardImage: function dispatchBoardImage(id, file) {
            var transactionId = (0, _undoRedoTransactionManager.getNewTransactionId)();
            dispatch((0, _elementActions.updateElement)({ id: id, changes: { icon: null }, transactionId: transactionId }));
            dispatch((0, _elementAttachmentActions.uploadAttachment)({ id: id, file: file, imageType: _mediaConstants.IMAGE_TYPES.BOARD, transactionId: transactionId }));
        },
        dispatchClosePopup: function dispatchClosePopup() {
            return dispatch((0, _popupActions.closePopup)());
        }
    };
};

var BoardImagePickerContainer = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec(_class = function (_React$Component) {
    _inherits(BoardImagePickerContainer, _React$Component);

    function BoardImagePickerContainer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BoardImagePickerContainer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BoardImagePickerContainer.__proto__ || Object.getPrototypeOf(BoardImagePickerContainer)).call.apply(_ref, [this].concat(args))), _this), _this.uploadImage = function (imageFile) {
            var _this$props = _this.props,
                dispatchBoardImage = _this$props.dispatchBoardImage,
                dispatchClosePopup = _this$props.dispatchClosePopup,
                selectedElements = _this$props.selectedElements;


            var validationErrors = (0, _fileValidator.validateImageFile)(imageFile);
            if (validationErrors) {
                // TODO if validation errors, show them to the user
                return;
            }

            selectedElements.forEach(function (element) {
                return dispatchBoardImage(element.get('id'), imageFile);
            });
            dispatchClosePopup();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BoardImagePickerContainer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_BoardImagePicker2.default, _extends({}, this.props, { openFileSelect: this.openFileSelect,
                uploadImage: this.uploadImage }));
        }
    }]);

    return BoardImagePickerContainer;
}(_react2.default.Component)) || _class);


BoardImagePickerContainer.propTypes = {
    gridSize: _propTypes2.default.number.isRequired,
    selectedElements: _propTypes2.default.object.isRequired,
    selectedImage: _propTypes2.default.string,
    dispatchBoardImage: _propTypes2.default.func,
    dispatchClosePopup: _propTypes2.default.func
};

exports.default = BoardImagePickerContainer;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/tabContent/imagePicker/BoardImagePickerContainer.js
// module id = 2244
// module chunks = 0